import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PopUp.css";

/**

 * PopUp

 * @augments {Component<Props, State>}

 */
export default class PopUpInfo extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this)
    }

    handleClose = () => {
        const showPopUp = false;
        this.props.closePopUp(showPopUp, this.props.previousValue);
    }

    handleChange = () => {
        const showPopUp = false;
        this.props.changePopUp(showPopUp, this.props.currentValue);
    }

    render() {
        const props = this.props;
        return (
            props.showPopUp ?
                <div id="popUpInfo" className="modal">
                    <div className="modal-content">
                        <span onClick={this.handleClose} className="close">&times;</span>
                        <h2>{props.title}</h2>
                        <div className="help-content">
                            {props.text.split(';').map(e => {
                                return <p key={e}>{e}</p>;
                            })}
                        </div>
                    </div>
                </div> : null
        )
    }
}
// props for Component from Survey Component
PopUpInfo.propTypes = {
    /** show popup true or false
     *Default: false */
    showPopUp: PropTypes.bool,
    /** previous Value in Dropdown */
    title: PropTypes.string,
    text: PropTypes.string,
    closePopUp: PropTypes.func,
};

PopUpInfo.defaultProps = {
    showPopUp: false
};





